import React, { useState } from 'react';
import {
  Box, VStack, Input, Button, Text, Heading, Alert, AlertIcon, FormControl, FormLabel, Textarea, Select, useToast
} from '@chakra-ui/react';
import { WarningIcon } from '@chakra-ui/icons'; // Aggiunto per completezza

const API_URL = `http://${process.env.REACT_APP_API_BASE_URL}/api/`;

const ReportForm = ({ navigate }) => {
  const [formData, setFormData] = useState({
    numero_telefono: '',
    tag: '',
    dettagli: '',
    // L'utente_id dovrebbe essere generato in una vera app
    utente_id: 'WEB_USER_' + Date.now().toString(36), 
  });
  const [loading, setLoading] = useState(false);
  const toast = useToast();

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.numero_telefono.trim() || !formData.tag) {
      toast({
        title: "Dati Mancanti.",
        description: "Numero di telefono e Tipo di Truffa sono campi obbligatori.",
        status: "warning",
        duration: 5000,
        isClosable: true,
      });
      return;
    }

    setLoading(true);

    try {
      // Rotta API: POST /api/segnalazioni/segnala
      const response = await fetch(`${API_URL}segnalazioni/segnala`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          // Aggiungi qui un eventuale header di autenticazione per protectApi
        },
        body: JSON.stringify(formData),
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.msg || 'Errore durante la segnalazione.');
      }

      toast({
        title: "Segnalazione Inviata!",
        description: `Grazie per aver segnalato ${formData.numero_telefono}. Rischio attuale: ${data.classificazione_rischio}.`,
        status: "success",
        duration: 6000,
        isClosable: true,
      });

      // Reset del form e reindirizzamento alla homepage per verifica
      setFormData({
        numero_telefono: '',
        tag: '',
        dettagli: '',
        utente_id: 'WEB_USER_' + Date.now().toString(36), 
      });
      navigate('check'); 

    } catch (err) {
      console.error("API Error:", err);
      toast({
        title: "Errore di Invio.",
        description: err.message,
        status: "error",
        duration: 9000,
        isClosable: true,
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box p={8} maxW="lg" mx="auto" w="full">
      <Heading size="md" mb={6} color="red.600" display="flex" alignItems="center">
        <WarningIcon mr={3} /> Nuova Segnalazione di Truffa
      </Heading>
      <Text color="gray.600" mb={6}>Aiutaci a proteggere la comunità. Ogni segnalazione è importante.</Text>

      <Box as="form" onSubmit={handleSubmit} p={6} borderRadius="xl" boxShadow="xl" bg="white">
        <VStack spacing={4} align="stretch">
          
          <FormControl isRequired>
            <FormLabel>Numero di Telefono Segnalato</FormLabel>
            <Input
              type="tel"
              name="numero_telefono"
              value={formData.numero_telefono}
              onChange={handleChange}
              placeholder="Inserisci il numero"
            />
          </FormControl>

          <FormControl isRequired>
            <FormLabel>Tipo di Truffa (Tag)</FormLabel>
            <Select 
              name="tag"
              value={formData.tag}
              onChange={handleChange}
              placeholder="Seleziona il tipo di frode"
            >
              <option value="Phishing Bancario">Phishing Bancario</option>
              <option value="Finto Operatore">Finto Operatore Assistenza</option>
              <option value="Investimenti Aggressivi">Investimenti Aggressivi</option>
              <option value="Sondaggio Commerciale">Sondaggio Commerciale Molesto</option>
              <option value="Altro">Altro (Specifica nei dettagli)</option>
            </Select>
          </FormControl>
          
          <FormControl>
            <FormLabel>Dettagli dell'Accaduto (Opzionale)</FormLabel>
            <Textarea
              name="dettagli"
              value={formData.dettagli}
              onChange={handleChange}
              placeholder="Descrivi brevemente cosa è successo"
            />
          </FormControl>
          
          <Alert status="info" borderRadius="md" mt={2}>
            <AlertIcon />
            Il tuo ID utente (anonimo) è: {formData.utente_id}
          </Alert>

          <Button 
            type="submit" 
            colorScheme="red" 
            size="lg" 
            isLoading={loading} 
            mt={4}
          >
            Invia Segnalazione
          </Button>
        </VStack>
      </Box>

      <Button 
        mt={6} 
        variant="link"
        colorScheme="teal"
        onClick={() => navigate('check')}
      >
        Torna alla Verifica Rischio
      </Button>
    </Box>
  );
};

export default ReportForm;